const Mtxs = {
  /// /////////////////////////
  //        APP
  /// /////////////////////////

  SET_LATEST_VERSION: 'SET_LATEST_VERSION',
  SET_APP_VERSION_MISMATCH: 'SET_APP_VERSION_MISMATCH',
  SET_ONLINE_STATUS: 'SET_ONLINE_STATUS',

  /// /////////////////////////
  //        ADMIN
  /// /////////////////////////

  SET_AUTH_EXPIRY: 'SET_AUTH_EXPIRY',
  SET_AUTH_LOGGED_OUT: 'SET_AUTH_LOGGED_OUT',
  SET_AUTH_USER: 'SET_AUTH_USER',
  SET_TOKEN: 'SET_TOKEN',
  SET_SETTINGS: 'SET_SETTINGS',
  ADJUST_NUM_SAVING: 'ADJUST_NUM_SAVING',
  ADJUST_DIRT_SCORE: 'ADJUST_DIRT_SCORE',
  ADD_TO_DIRTIES: 'ADD_TO_DIRTIES',
  REMOVE_FROM_DIRTIES: 'REMOVE_FROM_DIRTIES',
  ADD_TO_ACCT_DIRTIES: 'ADD_TO_ACCT_DIRTIES',
  REMOVE_FROM_ACCT_DIRTIES: 'REMOVE_FROM_ACCT_DIRTIES',
  SET_UPLOAD_WIDGET: 'SET_UPLOAD_WIDGET',

  /// /////////////////////////
  //        CUSTOMER
  /// /////////////////////////

  SET_CUSTOMER_LOGGED_IN: 'SET_CUSTOMER_LOGGED_IN',
  SET_CUSTOMER_LOGGED_OUT: 'SET_CUSTOMER_LOGGED_OUT',
  SET_CUSTOMER: 'SET_CUSTOMER',
  UPDATE_CUSTOMER: 'UPDATE_CUSTOMER',
  CACHE_CUSTOMER: 'CACHE_CUSTOMER',

  /// /////////////////////////
  //     ITEM + SECTION
  /// /////////////////////////

  SET_ITEMS: 'SET_ITEMS',
  SET_ITEM_STOCK: 'SET_ITEM_STOCK',
  SET_SECTIONS: 'SET_SECTIONS',

  /// /////////////////////////
  //        CART
  /// /////////////////////////

  SET_CART: 'SET_CART',
  SET_FULFILLMENT_SLOT: 'SET_FULFILLMENT_SLOT',
  SET_ORDER_FORM_VALID: 'SET_ORDER_FORM_VALID',
  SET_SELECTED_AVAILABILITY: 'SET_SELECTED_AVAILABILITY',
  SET_FULFILLMENT_TYPE: 'SET_FULFILLMENT_TYPE',
  SET_DELIVERY_FEE: 'SET_DELIVERY_FEE',
  SET_FAMILY_DISCOUNT: 'SET_FAMILY_DISCOUNT',
  SET_DELIVERY_ADDRESS: 'SET_DELIVERY_ADDRESS',
  SET_SPECIAL_INSTRUCTIONS: 'SET_SPECIAL_INSTRUCTIONS',
  SET_IS_GIFT: 'SET_IS_GIFT',
  SET_GIFTEE_DETAILS: 'SET_GIFTEE_DETAILS',
  SET_TIP: 'SET_TIP',
  REMOVE_TIP: 'REMOVE_TIP',
  SET_CART_ITEMS: 'SET_CART_ITEMS',
  ADD_CART_ITEM: 'ADD_CART_ITEM',
  REMOVE_CART_ITEM: 'REMOVE_CART_ITEM',
  UPDATE_CART_ITEM: 'UPDATE_CART_ITEM',
  SET_CART_ON_SCREEN: 'SET_CART_ON_SCREEN',
  SET_ORDER_CONF_SNACKBAR: 'SET_ORDER_CONF_SNACKBAR',
  SET_OVERSOLD_DIALOG: 'SET_OVERSOLD_DIALOG',
  SET_ORDER_ID: 'SET_ORDER_ID',
  SET_PLACING_ORDER: 'SET_PLACING_ORDER',
  SET_ORDER_ERROR: 'SET_ORDER_ERROR',
  SET_ORDER_TIMEOUT: 'SET_ORDER_TIMEOUT',
  SET_HIGHLIGHTED_ITEM_ID: 'SET_HIGHLIGHTED_ITEM_ID',
  SET_NUM_ORDER_ATTEMPTS: 'SET_NUM_ORDER_ATTEMPTS',
  SET_CART_ERROR_EMPHASIS: 'SET_CART_ERROR_EMPHASIS',

  /// /////////////////////////
  //        MISC
  /// /////////////////////////

  SET_ACCOUNT_CREATED_SNACKBAR: 'SET_ACCOUNT_CREATED_SNACKBAR',
  SET_ACCOUNT_UPDATED_SNACKBAR: 'SET_ACCOUNT_UPDATED_SNACKBAR',
  SET_AUTH_LOGGED_OUT_SNACKBAR: 'SET_AUTH_LOGGED_OUT_SNACKBAR',

  /// /////////////////////////
  //        ORDER
  /// /////////////////////////

  SET_INVOICE_PAYMENT_DIALOG: 'SET_INVOICE_PAYMENT_DIALOG',
  SET_INVOICE_FULFILLMENT_DIALOG: 'SET_INVOICE_FULFILLMENT_DIALOG',
  SET_ORDER: 'SET_ORDER',
  SET_ORDERS: 'SET_ORDERS',
  UPDATE_ORDER_FIELDS: 'UPDATE_ORDER_FIELDS',

  /// /////////////////////////
  //        ORDER ITEM
  /// /////////////////////////

  SET_ORDER_ITEMS: 'SET_ORDER_ITEMS',

  /// /////////////////////////
  //        SHOP
  /// /////////////////////////

  SET_SHOP: 'SET_SHOP',
  SET_SHOP_LOADING_STATE: 'SET_SHOP_LOADING_STATE',
  SET_SHOP_FETCH_ERROR: 'SET_SHOP_FETCH_ERROR',
  UPDATE_SHOP_SETTING: 'UPDATE_SHOP_SETTING',

  /// /////////////////////////
  //        SHOP ENTITIES
  /// /////////////////////////

  SET_AVAILABILITIES: 'SET_AVAILABILITIES',
  SET_CUSTOMERS: 'SET_CUSTOMERS',
}
export default Mtxs
